import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { returnParamiters } from '../../relatorio/relatorio.utils';
import * as commonActions from '@common/common.action';
import SolicitacaoApi from '../solicitacao.api';
import ModalCriarSolicitacao from './CriarSolicitacao';
import Filtro from './Filtro';
import Grid from './Grid';
import { useIntl } from 'react-intl';
import CommonFunctions from '@common/util/functions.common';

function Laudos () {
  const dispatch = useDispatch();

  const [filtro, setFiltro] = useState({});
  const [lista, setLista] = useState([]);
  const [total, setTotal] = useState(0);
  const [pagina, setPagina] = useState(1);
  const [showModalCriar, setShowModalCriar] = useState(false);
  const [laudoSelecionado, setLaudoSelecionado] = useState({});
  const intl = useIntl();

  useEffect(() => {
    const { tipo } = filtro;
    tipo && filtrar(filtro);
  }, [pagina]);

  const onclickLine = item => {
    setLaudoSelecionado(item.data);
    setShowModalCriar(true);
  };

  const filtrar = async filtro => {
    const { medico, periodoInicial, periodoFinal, tipo, value } = filtro;

    let params = returnParamiters({
      periodoInicial,
      periodoFinal,
      tipo,
      value
    });

    if (tipo.indexOf('dt') >= 0) {
      const result = CommonFunctions.validaData(periodoInicial, periodoFinal, intl, commonActions);

      if (!result.valid) {
        dispatch(commonActions.showAlerta('alerta', result.message, 3000));
        return;
      }
    }

    if (medico) params.medicoSolicitante = medico;

    dispatch(commonActions.showFadeCarregando(true));
    const response = await SolicitacaoApi.getLaudos(pagina, params);
    pagina === 1 && setTotal(response.total);

    setLista(response.listagem);
    dispatch(commonActions.showFadeCarregando(false));
  };

  return (
    <div>
      <ModalCriarSolicitacao
        onModal={() => setShowModalCriar(!showModalCriar)}
        showModal={showModalCriar}
        laudoSelecionado={laudoSelecionado}
      />
      <Filtro setFiltro={setFiltro} filtro={filtro} filtrar={filtrar} />
      {!!lista.length && (
        <Grid
          lista={lista}
          totalItens={total}
          pagina={pagina}
          totalItensPage={20}
          setPagina={setPagina}
          onclickLine={onclickLine}
        />
      )}
      {!lista.length && (
        <div className='icone-semdados'>
          <i className='inicial-icons mv-basico-solicitar'></i>
        </div>
      )}
    </div>
  );
}

export default Laudos;



// WEBPACK FOOTER //
// ./src/pages/solicitacao/Laudos/index.js